import type { SVGProps } from 'react';

/** Figma `user-hand-up.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const UserHandUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.42408 7.03009C2.95988 6.89615 3.50281 7.22191 3.63676 7.7577L4.14605 9.79486C4.95914 13.0472 7.52138 15.5688 10.7793 16.3336H21.3333C24.1213 16.3336 26.468 18.4204 26.7938 21.1893L27.6598 28.5501C27.7243 29.0986 27.3319 29.5955 26.7834 29.6601C26.2349 29.7246 25.738 29.3322 25.6735 28.7837L24.8075 21.423C24.6002 19.6613 23.1072 18.3336 21.3333 18.3336H10.5568L10.4497 18.3098C6.40274 17.4104 3.21124 14.3018 2.20576 10.2799L1.69648 8.24277C1.56253 7.70698 1.88829 7.16404 2.42408 7.03009Z"
      fill="#FF2D55"
    />
    <path
      opacity="0.5"
      d="M10.6666 18.334V24.0007C10.6666 26.5148 10.6666 27.7719 11.4477 28.5529C12.2287 29.334 13.4858 29.334 16 29.334C18.5141 29.334 19.7712 29.334 20.5522 28.5529C21.3333 27.7719 21.3333 26.5148 21.3333 24.0007V18.334H10.6666Z"
      fill="#FF2D55"
    />
    <circle opacity="0.8" cx="16" cy="7.99935" r="5.33333" fill="#FF2D55" />
  </svg>
);
